import React from "react";
import styled from "styled-components";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";

TimeAgo.addLocale(en);
const timeAgo = new TimeAgo("en-US");

import DeleteForeverOutlined from "@material-ui/icons/DeleteForeverOutlined";

import { Link } from "gatsby";
import ShareButton from "../ShareButton";
import { UserQuizData } from "../interfaces";

const Gallery = styled.ul`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-gap: 10px;
  list-style: none;
  padding: 0;
  li {
    border: 2px solid greenyellow;
    transition: all 200ms ease-in-out;
    &:hover {
      border: 2px solid #999;
    }
    padding: 10px 20px;
    position: relative;
    display: grid;
    grid-gap: 10px;
    min-height: 200px;
    span {
      font-size: 0.75rem;
    }
  }
`;

const DeleteButton = styled(DeleteForeverOutlined)`
  position: absolute;
  height: 10px;
  width: 10px;
  top: 10px;
  right: 10px;
  color: #ccc;
  cursor: pointer;
  &:hover {
    color: tomato;
  }
`;

const QuizActions = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  @media (max-width: 700px) {
    grid-template-columns: auto;
    grid-template-rows: 1fr;
  }
  a {
    border: 1px solid #999;
    color: #333;
    padding: 8px 12px;
    width: 100%;
    box-sizing: border-box;
    text-align: center;
    text-decoration: none;
    height: 50px;
    display: grid;
    place-items: center;
    white-space: nowrap;
  }
  button {
    border: 1px solid transparent;
    height: 50px;
    background: greenyellow;
    color: #333;
    padding: 8px 12px;
    width: 100%;
    box-sizing: border-box;
    text-align: center;
    text-decoration: none;
    cursor: pointer;
  }
`;

interface Props {
  data: Record<string, UserQuizData>;
  location: any;
}

const QuizGallery = ({ data, location }: Props) => {
  return (
    <Gallery>
      {Object.keys(data).map((key) => (
        <li key={key}>
          <DeleteButton onClick={() => {}} />
          <h3>{data[key].quizName}</h3>
          <QuizActions>
            <Link to={`/poll?id=${data[key].quizUuid}`}>Preview Poll</Link>
            <ShareButton
              config={{
                params: {
                  title: `${data[key].quizName}.`,
                  text: " Take this quiz now and have your say.",
                  url: `${location.origin}/poll?id=${data[key].quizUuid}`,
                },
                onShareSuccess: () => console.log("Success"),
                onShareError: (error: Error) => console.log("error", error),
              }}
              fallbackUrl={`${location.origin}/poll?id=${data[key].quizUuid}`}
              onClickFallback={() => {
                console.log("fallback");
              }}
            />
            <Link to={`/results?id=${data[key].quizUuid}`}>View Results</Link>
          </QuizActions>
          {data[key].createdAt && (
            <span>Created {timeAgo.format(data[key].createdAt)}</span>
          )}
        </li>
      ))}
    </Gallery>
  );
};

export default QuizGallery;
